/**
 * BB Cart Swap — for each Special Order line item in cart, surface in-stock mesh
 * alternatives with one-click swap (no manual remove/re-add).
 *
 * Bootstraps off the existing .CartItem__SpecialOrder divs rendered by Liquid.
 * For each, fetches /products/{handle}.js for full variant data, filters to
 * non-SO siblings (same Panel Size + Frame Type), renders buttons, swaps via
 * /cart/add.js + /cart/change.js on click.
 */
(function () {
  'use strict';

  // Same cross-product map as bb-mesh-swap.js — kept in sync manually.
  var PRODUCT_ALTERNATIVES = {
    'rust-patina-hog-wire-fence-panels-hog-panels-premade-or-unframed-the-red-rock': [
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'the-tough-panel-silver-hog-wire-fence-panel-gauge-6-silver-hog-wire-fence-framed-or-unframe', label: 'Silver Hog Wire Fence Panels' },
      { handle: 'brown-hog-wire-fence-panel-gauge-6-coffee-brown-hog-panels-premade-or-unframed-the-tough-panel', label: 'Brown Hog Wire Fence Panels' },
    ],
    'rust-patina-hog-wire-deck-railing-panels-premade-or-unframed-the-copperhead': [
      { handle: 'hog-wire-deck-railing', label: 'Black Hog Wire Deck Railing' },
      { handle: 'silver-hog-wire-deck-railing-hog-wire-railing-deck-panels', label: 'Silver Hog Wire Deck Railing' },
      { handle: 'brown-hog-wire-deck-railing-panels-premade-or-unframed-the-acadia-copy', label: 'Brown Hog Wire Deck Railing' },
    ],
    'rust-cattle-panel-fence-cattle-panels-premade-or-unframed-the-aberdeen': [
      { handle: 'black-cattle-panel-fence-cattle-panels-premade-or-unframed-the-angus', label: 'Black Cattle Panel Fence' },
      { handle: 'silver-cattle-panel-fence-cattle-panels-premade-or-unframed-the-holstein', label: 'Silver Cattle Panel Fence' },
      { handle: 'brown-cattle-panel-fence-cattle-panels-premade-or-unframed-the-highland', label: 'Brown Cattle Panel Fence' },
    ],
    'dark-green-hog-wire-deck-railing-panels-premade-or-unframed-the-cypress': [
      { handle: 'hog-wire-deck-railing', label: 'Black Hog Wire Deck Railing' },
      { handle: 'silver-hog-wire-deck-railing-hog-wire-railing-deck-panels', label: 'Silver Hog Wire Deck Railing' },
      { handle: 'brown-hog-wire-deck-railing-panels-premade-or-unframed-the-acadia-copy', label: 'Brown Hog Wire Deck Railing' },
    ],
    'green-hog-wire-fence-panels-hog-panels-premade-or-unframed-the-amazon': [
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'the-tough-panel-silver-hog-wire-fence-panel-gauge-6-silver-hog-wire-fence-framed-or-unframe', label: 'Silver Hog Wire Fence Panels' },
      { handle: 'brown-hog-wire-fence-panel-gauge-6-coffee-brown-hog-panels-premade-or-unframed-the-tough-panel', label: 'Brown Hog Wire Fence Panels' },
    ],
    'green-cattle-panel-fence-cattle-panels-premade-or-unframed-the-galloway': [
      { handle: 'black-cattle-panel-fence-cattle-panels-premade-or-unframed-the-angus', label: 'Black Cattle Panel Fence' },
      { handle: 'silver-cattle-panel-fence-cattle-panels-premade-or-unframed-the-holstein', label: 'Silver Cattle Panel Fence' },
      { handle: 'brown-cattle-panel-fence-cattle-panels-premade-or-unframed-the-highland', label: 'Brown Cattle Panel Fence' },
    ],
    'brown-frame-metal-privacy-fence-kit': [
      { handle: 'black-frame-metal-privacy-fence-kit', label: 'Zero-Maintenance Privacy Fence Kit (Black Frame)' },
    ],
    'black-aluminum-privacy-fence-panels-96-wide-x-96-high': [
      { handle: 'black-frame-metal-privacy-fence-kit', label: 'Zero-Maintenance Privacy Fence Kit (Black Frame)' },
      { handle: 'corrugated-metal-fence', label: 'Corrugated Metal Privacy Fence Panels' },
    ],
    'black-aluminum-privacy-fence-panels-69-high': [
      { handle: 'black-frame-metal-privacy-fence-kit', label: 'Zero-Maintenance Privacy Fence Kit (Black Frame)' },
      { handle: 'corrugated-metal-fence', label: 'Corrugated Metal Privacy Fence Panels' },
    ],
    'black-aluminum-privacy-fence-panels-46-high': [
      { handle: 'black-frame-metal-privacy-fence-kit', label: 'Zero-Maintenance Privacy Fence Kit (Black Frame)' },
      { handle: 'corrugated-metal-fence', label: 'Corrugated Metal Privacy Fence Panels' },
    ],
    'black-aluminum-screen-fence-panels-46-high': [
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'black-frame-hog-wire-fence-kit', label: 'Zero-Maintenance Hog Wire Fence Kit (Black Frame)' },
    ],
    'black-aluminum-screen-fence-panels-72-wide-x-69-high': [
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'black-frame-hog-wire-fence-kit', label: 'Zero-Maintenance Hog Wire Fence Kit (Black Frame)' },
    ],
    'black-aluminum-privacy-gate-40-wide-x-44-5-high': [
      { handle: 'gates-for-full-metal-fence-kit', label: 'Zero-Maintenance Metal Fence Gate (Black)' },
    ],
    'black-aluminum-privacy-gate-40-wide-x-67-5-high': [
      { handle: 'gates-for-full-metal-fence-kit', label: 'Zero-Maintenance Metal Fence Gate (Black)' },
    ],
    'black-aluminum-screen-gates-40-wide-x-44-5-high': [
      { handle: 'gates-for-full-metal-fence-kit', label: 'Zero-Maintenance Metal Fence Gate (Black)' },
    ],
    'steel-board-fencing': [
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'black-cattle-panel-fence-cattle-panels-premade-or-unframed-the-angus', label: 'Black Cattle Panel Fence' },
    ],
    '316-stainless-steel-wire-fence-panels': [
      { handle: 'the-tough-panel-silver-hog-wire-fence-panel-gauge-6-silver-hog-wire-fence-framed-or-unframe', label: 'Silver Hog Wire Fence Panels' },
      { handle: 'hog-wire-fence-panels', label: 'Black Hog Wire Fence Panels' },
      { handle: 'brown-hog-wire-fence-panel-gauge-6-coffee-brown-hog-panels-premade-or-unframed-the-tough-panel', label: 'Brown Hog Wire Fence Panels' },
    ],
    '316-stainless-steel-deck-railings': [
      { handle: 'silver-hog-wire-deck-railing-hog-wire-railing-deck-panels', label: 'Silver Hog Wire Deck Railing' },
      { handle: 'hog-wire-deck-railing', label: 'Black Hog Wire Deck Railing' },
      { handle: 'brown-hog-wire-deck-railing-panels-premade-or-unframed-the-acadia-copy', label: 'Brown Hog Wire Deck Railing' },
    ],
    '316-stainless-steel-wire-deck-railing': [
      { handle: 'silver-hog-wire-deck-railing-hog-wire-railing-deck-panels', label: 'Silver Hog Wire Deck Railing' },
      { handle: 'hog-wire-deck-railing', label: 'Black Hog Wire Deck Railing' },
      { handle: 'brown-hog-wire-deck-railing-panels-premade-or-unframed-the-acadia-copy', label: 'Brown Hog Wire Deck Railing' },
    ],
  };

  function isSoMesh(val) {
    if (!val) return false;
    return /\b1\s*["'′″“”’]?\s*[x×]\s*1\b/i.test(val)
        || /\b2\s*["'′″“”’]?\s*[x×]\s*6\b/i.test(val);
  }

  // Per-product variant SO rules (in addition to universal mesh check).
  // Each entry: array of { optionRegex, valueRegex }.
  var VARIANT_SO_RULES = {
    'hog-wire-gates-rigid-black-hog-wire-gauge-6': [
      { optionRegex: /color/i, valueRegex: /corten|rust|patina/i },
      { optionRegex: /color/i, valueRegex: /green/i },
    ],
    'cattle-panel-gates-rigid-cattle-panel-fence-gate-gauge-6-cattle-panels-w-hinges-hardware': [
      { optionRegex: /color/i, valueRegex: /corten|rust|patina/i },
      { optionRegex: /color/i, valueRegex: /green/i },
    ],
    'metal-fence-posts-for-wood-fence': [
      { optionRegex: /color/i, valueRegex: /brown/i },
      { optionRegex: /width/i, valueRegex: /5\s*["\u201d]?\s*[x\u00d7]\s*5/i },
    ],
  };

  // Returns { triggered: bool, optionName: string|null } — variant SO state.
  // selectedOpts is a plain object: { "Color": "Coffee Brown", "Width": "5\" x 5\"", ... }
  function isVariantSO(productHandle, selectedOpts) {
    // Universal mesh check
    for (var k in selectedOpts) {
      if (Object.prototype.hasOwnProperty.call(selectedOpts, k) && /wire.?opening|mesh/i.test(k) && isSoMesh(selectedOpts[k])) {
        return { triggered: true, optionName: k };
      }
    }
    // Per-product rules
    var rules = VARIANT_SO_RULES[productHandle] || [];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      for (var key in selectedOpts) {
        if (!Object.prototype.hasOwnProperty.call(selectedOpts, key)) continue;
        if (r.optionRegex.test(key) && r.valueRegex.test(String(selectedOpts[key] || ''))) {
          return { triggered: true, optionName: key };
        }
      }
    }
    return { triggered: false, optionName: null };
  }

  // Build a plain { name: value } map for a product variant from /products/{handle}.js
  function variantOptsMap(product, variant) {
    var optsArr = product.options || [];
    var out = {};
    for (var i = 0; i < optsArr.length; i++) {
      var name = typeof optsArr[i] === 'string' ? optsArr[i] : (optsArr[i].name || '');
      if (name) out[name] = variant['option' + (i + 1)];
    }
    return out;
  }

  // Find non-SO sibling variants on the same product. Match all dimensions
  // EXCEPT the trigger option (which is the one we want to switch).
  function findNonSoSiblings(product, currentOptsMap, triggerOptionName) {
    return (product.variants || []).filter(function (v) {
      if (!v.available && (v.inventory_quantity || 0) <= 0) return false;
      var vMap = variantOptsMap(product, v);
      if (isVariantSO(product.handle, vMap).triggered) return false;
      for (var k in currentOptsMap) {
        if (k === triggerOptionName) continue;
        if (vMap[k] !== currentOptsMap[k]) return false;
      }
      return true;
    });
  }

  // Read mesh / panel size / frame from a variant's option array using the
  // product.options order. Shopify /products/{handle}.js returns options as
  // an array of strings (names), and variant.option1/2/3 as values.
  function variantOptionByName(product, variant, regex) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : (opts[i].name || '');
      if (regex.test(name)) {
        return variant['option' + (i + 1)] || (variant.options || [])[i] || null;
      }
    }
    return null;
  }

  function meshPriority(meshVal, preferFineFirst) {
    if (/2\s*["'′″“”’]?\s*[x×]\s*2/i.test(meshVal)) return preferFineFirst ? 1 : 2;
    if (/4\s*["'′″“”’]?\s*[x×]\s*4/i.test(meshVal)) return preferFineFirst ? 2 : 1;
    return 9;
  }

  async function fetchCart() {
    var r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  async function fetchProduct(handle) {
    var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('product fetch ' + r.status);
    return r.json();
  }

  // Cart line items use `options_with_values` (array of {name, value}) — different
  // shape from product variants (which have option1/option2/option3).
  function cartItemOption(item, regex) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (regex.test(String(opts[i].name || ''))) return opts[i].value;
    }
    return null;
  }
  async function cartAdd(variantId, qty) {
    var r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!r.ok) throw new Error('cart add failed: ' + r.status);
    return r.json();
  }
  async function cartRemove(lineKey) {
    var r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!r.ok) throw new Error('cart change failed: ' + r.status);
    return r.json();
  }

  // In-flight claim set — prevents concurrent renderAlternatives() calls from collecting
  // the same divs. Cleared per-div after the render attempt completes (success or fail).
  var _inFlight = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  // For each SO div, look up its line item independently (works for main cart + drawer).
  async function renderAlternatives() {
    var soDivs = Array.prototype.slice.call(document.querySelectorAll('.CartItem__SpecialOrder'))
      .filter(function (d) {
        if (d.dataset.altsRendered === '1') return false;
        if (d.querySelector('.CartItem__SO_AltsWrap')) { d.dataset.altsRendered = '1'; return false; }
        if (_inFlight && _inFlight.has(d)) return false;
        if (_inFlight) _inFlight.add(d); // claim synchronously, will clear after render
        return true;
      });
    if (!soDivs.length) return;

    try {
    var cart;
    try { cart = await fetchCart(); } catch (e) { return; }
    if (!cart.items || !cart.items.length) return;

    // Cache product fetches across SO divs
    var productCache = {};
    // Track which cart-line keys have already been rendered (cart-items.liquid renders
    // SO divs in BOTH a desktop block and a mobile block per line — only render once).
    var renderedLineKeys = {};

    for (var d = 0; d < soDivs.length; d++) {
      var div = soDivs[d];
      try {

      // Hard dedup: if this div already has an alts wrap appended (from a prior pass before the
      // drawer re-render replaced the dataset flag), skip.
      if (div.querySelector('.CartItem__SO_AltsWrap')) {
        div.dataset.altsRendered = '1';
        continue;
      }

      // Walk up to the containing CartItem and read the product link to identify which cart line this is.
      var lineEl = div.closest('.CartItem, [data-cart-item], .cart-item');
      if (!lineEl) lineEl = div.parentElement; // best-effort fallback
      var titleLink = lineEl && lineEl.querySelector('a[href*="/products/"]');
      if (!titleLink) continue;

      var href = titleLink.getAttribute('href') || '';
      var variantMatch = href.match(/[?&]variant=(\d+)/);
      var variantId = variantMatch ? parseInt(variantMatch[1], 10) : null;
      var handleMatch = href.match(/\/products\/([^?\/#]+)/);
      var handle = handleMatch ? handleMatch[1] : null;
      if (!handle) continue;

      // Match cart line by variant_id first, fallback to handle
      var item = null;
      if (variantId) item = cart.items.find(function (it) { return it.variant_id === variantId; });
      if (!item) item = cart.items.find(function (it) { return it.handle === handle; });
      if (!item) continue;

      // Per-line dedup: cart-items.liquid renders TWO SO divs per line (desktop + mobile blocks).
      // Only render alternatives once per cart line — skip subsequent divs for the same line.
      if (item.key && renderedLineKeys[item.key]) {
        div.dataset.altsRendered = '1';
        continue;
      }

      // Build a Capitalized-keyed map of the cart item's selected options for rules check
      var itemOptsMap = {};
      (item.options_with_values || []).forEach(function (o) { if (o && o.name) itemOptsMap[o.name] = o.value; });
      var variantSO = isVariantSO(item.handle, itemOptsMap);

      var hasSoMeshOnVariant = (item.options_with_values || []).some(function (o) {
        var n = String(o.name || '').toLowerCase();
        return /wire.?opening|mesh/.test(n) && isSoMesh(o.value);
      });

      // Whole-product OR variant-level SO (mesh, color, width)
      var isAnyVariantSo = hasSoMeshOnVariant || variantSO.triggered;

      var wrap = document.createElement('div');
      wrap.className = 'CartItem__SO_AltsWrap';
      wrap.style.cssText = 'margin-top:8px;padding-top:8px;border-top:1px dashed #f0ad4e;';
      var label = document.createElement('div');
      label.style.cssText = 'font-size:11px;font-weight:600;color:#7a4a00;margin-bottom:4px;letter-spacing:0.4px;text-transform:uppercase;';
      label.textContent = '⚡ Want it faster? Switch to:';
      wrap.appendChild(label);
      var renderedAny = false;

      // Variant-level non-mesh SO (color/width) — fetch product, find non-SO siblings via rules
      if (variantSO.triggered && !hasSoMeshOnVariant) {
        var prodForSibs = productCache[handle];
        if (!prodForSibs) {
          try { prodForSibs = await fetchProduct(handle); } catch (e) { prodForSibs = null; }
          if (prodForSibs) productCache[handle] = prodForSibs;
        }
        if (prodForSibs) {
          var siblingAlts = findNonSoSiblings(prodForSibs, itemOptsMap, variantSO.optionName);
          siblingAlts.slice(0, 2).forEach(function (v) {
            var vMap = variantOptsMap(prodForSibs, v);
            var altLabel = (vMap[variantSO.optionName] || '') + ' ' + variantSO.optionName.toLowerCase() + ' — skip the 6–8 week wait';
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'CartItem__SO_AltBtn';
            btn.dataset.lineKey = item.key;
            btn.dataset.targetVariantId = v.id;
            btn.dataset.targetQuantity = item.quantity;
            btn.style.cssText = 'margin:4px 6px 0 0;padding:6px 12px;background:#fff;border:1.5px solid #f0ad4e;border-radius:3px;color:#7a4a00;font-weight:600;font-size:12px;cursor:pointer;';
            btn.textContent = altLabel;
            wrap.appendChild(btn);
            renderedAny = true;
          });
        }
      }

      if (hasSoMeshOnVariant && !renderedAny) {
        // Variant-level mesh SO — suggest sibling variants on same product (different mesh)
        var product = productCache[handle];
        if (!product) {
          try { product = await fetchProduct(handle); } catch (e) { product = null; }
          if (product) productCache[handle] = product;
        }
        if (product) {
          var curMesh = variantOptionByName(product, item, /wire.?opening|mesh/i);
          var curSize = variantOptionByName(product, item, /panel\s*size|^size$/i);
          var curFrame = variantOptionByName(product, item, /frame/i);
          var alts = (product.variants || []).filter(function (v) {
            // Allow variants that are available OR have continue-when-OOS policy (Shopify allows
            // purchase). Don't gate on inventory_quantity since many products have continue policy.
            if (v.available === false && v.inventory_policy !== 'continue') return false;
            var m = variantOptionByName(product, v, /wire.?opening|mesh/i);
            if (isSoMesh(m)) return false;
            if (curSize && variantOptionByName(product, v, /panel\s*size|^size$/i) !== curSize) return false;
            if (curFrame && variantOptionByName(product, v, /frame/i) !== curFrame) return false;
            return true;
          });
          var preferFineFirst = /\b1\s*["'′″“”’]?\s*[x×]\s*1\b/i.test(curMesh || '');
          alts.sort(function (a, b) {
            var ma = variantOptionByName(product, a, /wire.?opening|mesh/i);
            var mb = variantOptionByName(product, b, /wire.?opening|mesh/i);
            return meshPriority(ma, preferFineFirst) - meshPriority(mb, preferFineFirst);
          });
          // Dedup by mesh value — product has multiple variants per mesh (different color
          // combos). Keep first variant per unique mesh so we suggest distinct mesh sizes.
          var seenMesh = {};
          alts = alts.filter(function (v) {
            var m = variantOptionByName(product, v, /wire.?opening|mesh/i);
            if (seenMesh[m]) return false;
            seenMesh[m] = true;
            return true;
          });
          alts.slice(0, 2).forEach(function (v) {
            var m = variantOptionByName(product, v, /wire.?opening|mesh/i);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'CartItem__SO_AltBtn';
            btn.dataset.lineKey = item.key;
            btn.dataset.targetVariantId = v.id;
            btn.dataset.targetQuantity = item.quantity;
            btn.style.cssText = 'margin:4px 6px 0 0;padding:6px 12px;background:#fff;border:1.5px solid #f0ad4e;border-radius:3px;color:#7a4a00;font-weight:600;font-size:12px;cursor:pointer;';
            btn.textContent = m + ' mesh — skip the 6–8 week wait';
            wrap.appendChild(btn);
            renderedAny = true;
          });
        }
      }

      // Whole-product SO — fall back to cross-product alternatives from PRODUCT_ALTERNATIVES
      if (!renderedAny) {
        var crossAlts = PRODUCT_ALTERNATIVES[handle] || [];
        crossAlts.slice(0, 3).forEach(function (alt) {
          var link = document.createElement('a');
          link.href = '/products/' + alt.handle;
          link.style.cssText = 'display:inline-block;margin:4px 6px 0 0;padding:6px 12px;background:#fff;border:1.5px solid #f0ad4e;border-radius:3px;color:#7a4a00;font-weight:600;font-size:12px;text-decoration:none;';
          link.textContent = alt.label + ' →';
          wrap.appendChild(link);
          renderedAny = true;
        });
      }

      if (renderedAny) {
        div.appendChild(wrap);
        div.dataset.altsRendered = '1';
        if (item && item.key) renderedLineKeys[item.key] = true;
      }

      } finally {
        // Always release the in-flight claim so a subsequent renderAlternatives can retry
        // this div if anything went wrong (network, missing item, etc).
        if (_inFlight) _inFlight.delete(div);
      }
    }
    } finally {
      // Outer finally — covers early returns (fetch fail, empty cart) by releasing
      // all claimed divs at once.
      if (_inFlight) soDivs.forEach(function (d) { _inFlight.delete(d); });
    }
  }

  // One-time delegated click handler for swap buttons
  function bindClicks() {
    if (window.__BB_CART_SWAP_BOUND__) return;
    window.__BB_CART_SWAP_BOUND__ = true;
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('.CartItem__SO_AltBtn');
      if (!btn) return;
      e.preventDefault();
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Switching…';
      try {
        var newVariantId = parseInt(btn.dataset.targetVariantId, 10);
        var qty = parseInt(btn.dataset.targetQuantity, 10) || 1;
        var lineKey = btn.dataset.lineKey;
        await cartAdd(newVariantId, qty);
        await cartRemove(lineKey);
        window.location.reload();
      } catch (err) {
        btn.disabled = false;
        btn.textContent = 'Failed — please try again';
        setTimeout(function () { btn.textContent = origText; }, 3000);
      }
    });
  }

  function init() {
    bindClicks();
    renderAlternatives();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-render after cart updates — broad coverage of theme + Shopify events
  ['cart:updated','cart:refresh','cart:rerender','cart:item:add','cart:open','drawer:open','drawer:opened','on:cart:after-update','on:cart:after-add'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(init, 100); });
  });
  // Patch fetch to detect cart/* responses and re-init (catches any theme using fetch for cart)
  if (window.fetch && !window.__BB_CART_FETCH_PATCHED__) {
    window.__BB_CART_FETCH_PATCHED__ = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var url = (arguments[0] && (arguments[0].url || String(arguments[0]))) || '';
        if (/\/cart(\.js|\/(add|change|update|clear))/.test(url)) {
          p.then(function () { setTimeout(init, 300); }).catch(function(){});
        }
      } catch (e) {}
      return p;
    };
  }
  // Stable MutationObserver on body — catches drawer DOM swaps with debounce
  var debounceTimer = null;
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      // Only re-init if a mutation touches a node that contains or is a SO div
      var relevant = false;
      for (var i = 0; i < mutations.length && !relevant; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.classList?.contains('CartItem__SpecialOrder') || n.querySelector?.('.CartItem__SpecialOrder'))) {
            relevant = true; break;
          }
        }
      }
      if (!relevant) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }
  // Periodic safety net — every 2s, check for unrendered SO divs and process
  setInterval(function () {
    var unrendered = document.querySelectorAll('.CartItem__SpecialOrder:not([data-alts-rendered])');
    if (unrendered.length) init();
  }, 2000);
})();
